import { useQuery } from "@tanstack/react-query";
import { getLatestReport, getReportPayload } from "../api/report.js";
import type { ReportRunSummary, ReportPayload } from "../api/product-types.js";

export function useLatestReport(websiteId: string | undefined) {
  return useQuery<ReportRunSummary | null>({
    queryKey: ["report", websiteId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      return getLatestReport(websiteId);
    },
    enabled: websiteId != null,
  });
}

export function useReportPayload(
  websiteId: string | undefined,
  runId: string | undefined,
) {
  return useQuery<ReportPayload | null>({
    queryKey: ["report-payload", websiteId, runId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      if (!runId) throw new Error("runId is required");
      return getReportPayload(websiteId, runId);
    },
    enabled: websiteId != null && runId != null,
  });
}
